var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIndicators = function SvgIndicators(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m3 6 3-2.5 3.5 1.25L13 1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M6.333 10.063V14m0-3.937H3.89c-.311 0-.467 0-.586.047a.5.5 0 0 0-.242.191C3 10.395 3 10.517 3 10.762V14h3.333m0-3.937V7.7c0-.245 0-.368.06-.461a.5.5 0 0 1 .244-.191C6.755 7 6.91 7 7.222 7h1.556c.31 0 .467 0 .585.048.105.042.19.109.243.19.06.094.06.217.06.462v1.05M6.334 14h3.334m0 0H13V9.45c0-.245 0-.368-.06-.461a.5.5 0 0 0-.243-.191c-.119-.048-.275-.048-.586-.048H9.667m0 5.25V8.75"
  }))));
};
export { SvgIndicators as ReactComponent };
export default __webpack_public_path__ + "e338f4b337305713622a43975f3de771.svg";